class GraphQlError extends Error {
  constructor(message) {
    super(message);
    this.name = 'GraphQlError';
  }
}

export default GraphQlError;
